import { STATUS_CONFIG, ResourceStatus } from '../constants/resourceConstants';

/**
 * Get the color class for a given resource status
 *
 * @param status - The resource status
 * @returns Bootstrap color class name (e.g., 'success', 'danger', etc.)
 */
export const getStatusColor = (status: ResourceStatus): string => {
  const config = STATUS_CONFIG[status];
  return config?.color || 'secondary';
};

/** T-Card statuses - statuses that can be used in T-Card updates */
export const TCARD_STATUSES = [
  'available',
  'assigned',
  'os_rest',
  'os_personnel',
  'os_mechanical',
  'etr',
] as const;

/** Status options for select fields (T-Card statuses only) */
export const STATUS_SELECT_OPTIONS = TCARD_STATUSES.map((status) => ({
  label: STATUS_CONFIG[status].label,
  value: status,
}));
